module.exports = __webpack_public_path__ + "static/media/009ty@4x.d1c7b4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/009ty@4x.png
// module id = 415
// module chunks = 0 1